var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.text),expression:"text"}],attrs:{"type":"text","placeholder":"00:00","maxlength":"6"},domProps:{"value":(_vm.text)},on:{"input":[function($event){if($event.target.composing)return;_vm.text=$event.target.value},_vm.onInput],"blur":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }